import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Autocomplete extends Component {
  static propTypes = {
    options: PropTypes.instanceOf(Array).isRequired
  };
  state = {
    activeOption: 0,
    filteredOptions: [],
    showOptions: false,
    showAll: false,
    userInput: this.props.value ? this.props.value : ''
  };

  onChange = (e) => {
    const { options } = this.props;
    const userInput = e.currentTarget.value;

    const filteredOptions = options.filter(
      (optionName) =>
        optionName.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    this.props.changeValue(userInput);

    this.setState({
      showAll: false,
      activeOption: 0,
      filteredOptions,
      showOptions: true,
      userInput: e.currentTarget.value
    });
  };

  setValue = (str) => {
    this.setState({
      userInput: str
    })
  }

  onClick = (e) => {
    this.setState({
      showAll: false,
      activeOption: 0,
      filteredOptions: [],
      showOptions: false,
      userInput: e.currentTarget.innerText
    });

    this.props.changeValue(e.currentTarget.innerText);
  };
  onKeyDown = (e) => {
    const { activeOption, filteredOptions } = this.state;

    if (e.keyCode === 13) {
      this.setState({
        activeOption: 0,
        showOptions: false,
        userInput: filteredOptions[activeOption]
      });

      this.props.changeValue(filteredOptions[activeOption]);
    } else if (e.keyCode === 38) {
      if (activeOption === 0) {
        return;
      }
      this.setState({ activeOption: activeOption - 1 });
    } else if (e.keyCode === 40) {
      if (activeOption === filteredOptions.length - 1) {
        return;
      }
      this.setState({ activeOption: activeOption + 1 });
    }

    this.setState({
      showAll: false
    })
  };

  onBlur = (e) => {
    // setTimeout(
    //     function() {
    //       this.setState({
    //         showAll: false,
    //         filteredOptions: []
    //       })

    //       if (this.state.showOptions) {
    //         this.setState({
    //           activeOption: 0,
    //           filteredOptions: [],
    //           showOptions: false
    //         });
    //       }
    //     }
    //     .bind(this),
    //     100
    // );
  }

  closeDropDown() {
    this.setState({
      showAll: false,
      filteredOptions: []
    })

    if (this.state.showOptions) {
      this.setState({
        activeOption: 0,
        filteredOptions: [],
        showOptions: false
      });
    }
  }

  showAllList() {
    if (this.state.filteredOptions.length) {
      this.nameInput.blur();

      this.setState({
        showAll: false,
        filteredOptions: []
      })
    } else {
      var options = this.props.options;

      if (this.state.userInput) {
        options = this.props.options.filter(
          (optionName) =>
            optionName.toLowerCase().indexOf(this.state.userInput.toLowerCase()) > -1
        );
      }

      this.setState({
        showAll: true,
        activeOption: 0,
        filteredOptions: options
      }, function(){
        this.nameInput.focus();
      })
    }
  }

  render() {

    const {
      onChange,
      onClick,
      onKeyDown,
      onBlur,

      state: { activeOption, filteredOptions, showOptions, userInput, showAll }
    } = this;

    const { placeholder } = this.props;
    
    let optionList;
    if ((showOptions && userInput) || showAll) {
      if (filteredOptions.length) {
        optionList = (
          <ul className="options">
            {filteredOptions.map((optionName, index) => {
              let className;
              if (index === activeOption) {
                className = 'option-active';
              }
              return (
                <li className={className} key={index} onClick={onClick}>
                  {optionName}
                </li>
              );
            })}
          </ul>
        );
      } else {
        optionList = (
          <ul className="no-options">
            <li>Item not found!</li>
          </ul>
        );
      }
    }
    return (
      <React.Fragment>
        <div className="search">
          <input
            ref={(input) => { this.nameInput = input; }} 
            type="text"
            className="search-box"
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            value={userInput}
            placeholder={placeholder}
          />
          <div className="triangle-out" onClick={this.showAllList.bind(this)}>
            <div className="triangle-container">
              <div className="triangle"></div>
            </div>
          </div>
        </div>
        {optionList}
      </React.Fragment>
    );
  }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Autocomplete.js